import { render, staticRenderFns } from "./perfil-del-ciudadano.vue?vue&type=template&id=7282ec77&"
import script from "./perfil-del-ciudadano.vue?vue&type=script&lang=ts&"
export * from "./perfil-del-ciudadano.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports